/* global __webpack_public_path__:writable */
/* exported __webpack_public_path__ */
if (process.env.NODE_ENV === "production") {
  const el = document.querySelectorAll("[id^='app-']")[0];
  __webpack_public_path__ =
    el.dataset.wpPath + "/wp-content/plugins/mt-nft-cards/assets/";
}
